import React, { Component } from "react"
import { translate } from "react-translate"
import {
  Button,
  Modal,
  Form,
  Input,
  Label,
  Segment,
  Grid,
  Icon,
  Dropdown
} from "semantic-ui-react"
import _ from "lodash"
import "./ModalEditMateriau.css"
import MateriauxService from "./MateriauxService"
import { connect } from "react-redux"

const mapStateToProps = state => ({
  app: state.app
})

const options = [
  { key: 1, text: "text_dropdown_kg", value: 1 },
  { key: 2, text: "text_dropdown_m²", value: 2 },
  { key: 3, text: "text_dropdown_u", value: 3 },
  { key: 4, text: "text_dropdown_hr", value: 4 },
  { key: 5, text: "text_dropdown_ml", value: 5 },
  { key: 6, text: "text_dropdown_l", value: 6 }
]

class ModalEditMateriau extends Component {
  constructor(props) {
    super(props)
    this.state = {...props.row}
    this.eventHandler = this.eventHandler.bind(this)
    this.handleSaveWork = this.handleSaveWork.bind(this)
    this.handleSaveMaterial = this.handleSaveMaterial.bind(this)
    this.handleDeleteMaterial = this.handleDeleteMaterial.bind(this)
    this.handleDeleteWork = this.handleDeleteWork.bind(this)
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    if(prevProps.row !== this.props.row) {
      this.setState({
        ...this.props.row
      }, () => {
        console.log(this.props);
        this.rebuildOptions();
        this.computeAvailableOptions(this.props);
      });
    }
  }

  rebuildOptions = () =>  {
    console.log("Building options")
    var materials = this.state.materials
    var workforce = this.state.workforce
    // Retrieving materials

    MateriauxService.getAllMaterials(this.props.app.token).then(mats => {
      //mapping select options
      var matOptions = _.map(mats, x => {
        return {
          text: x.name,
          key: x.id,
          value: x
        }
      })
      // Avoid putting materials in options when they are arleady in the current work
      matOptions = _.filter(
        matOptions,
        x => _.findIndex(materials, y => y.idMat === x.key) < 0
      )

      // Mapping materials ids to real mats
      var mappedMaterials = _.map(materials, x => {
        var matInList = _.find(mats, y => y.id === x.idMat)
        return {
          ...matInList,
          quantity: x.quantity
        }
      })

      this.setState({
        materialsOptions: matOptions,
        materialList: mappedMaterials
      })
    })
    // MAin d'oeuvre
    MateriauxService.getAllWorkforces(this.props.app.token).then(mats => {
      //mapping select options
      var workOptions = _.map(mats, x => {
        return {
          text: x.name,
          key: x.id,
          value: x
        }
      })

      workOptions = _.filter(
        workOptions,
        x => _.findIndex(workforce, y => y.idWork === x.key) < 0
      )
      var mappedWorkForce = _.map(workforce, x => {
        var workForceInList = _.find(mats, y => y.id === x.idWork)

        return {
          ...workForceInList,
          quantity: x.quantity
        }
      })
      this.setState({
        workForceOption: workOptions,
        workForceList: mappedWorkForce
      })
    })
    let { t } = this.props
    var optionsCopy = _.clone(options)
    optionsCopy = _.map(optionsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      options: optionsCopy
    })
  }

  computeAvailableOptions(nextProps) {
      // Materials handling
      var currentMaterials = this.state.materialsOptions || []
      var newMaterials = _.filter(
        nextProps.materials || [],
        mat => mat.type === "materials"
      ).map(x => {
        return {
          text: x.name,
          key: x.id,
          value: x
        }
      })
      currentMaterials.unshift(...newMaterials)
      currentMaterials = _.uniqBy(currentMaterials, "key")
      var materialList = _.clone(this.state.materialList)
      materialList = _.map(materialList, x => {
        var idx = _.findIndex(
          currentMaterials,
          changedMat => changedMat.key === x.id
        )
        if (idx < -1) {
          return x
        }
        return { ...currentMaterials[idx].value, quantity: x.quantity }
      })

      var currentWorkForce = this.state.workForceOption || []
      var newWorkForce = _.filter(
        nextProps.materials || [],
        worf => worf.type === "workforce"
      ).map(x => {
        return {
          text: x.name,
          key: x.id,
          value: x
        }
      })
      currentWorkForce.unshift(...newWorkForce)
      currentWorkForce = _.uniqBy(currentWorkForce, "key")

      var workForceList = this.state.workForceList
      workForceList = _.map(workForceList, x => {
        var idx = _.findIndex(
          currentWorkForce,
          changedWor => changedWor.key === x.id
        )
        if (idx < -1) {
          return x
        }
        return { ...currentWorkForce[idx].value, quantity: x.quantity }
      })

      this.setState({
        materialsOptions: currentMaterials,
        materialList,
        workForceOption: currentWorkForce,
        workForceList
      })
  }

  eventHandler(event) {
    this.setState({
      toggle: event
    })
  }

  handleChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  handleSaveWork(value) {
    var tabCopy = this.state.workForceList
    tabCopy.push({
      ...value,
      quantity: 0
    })

    var tabOption = this.state.workForceOption

    var idx = _.findIndex(tabOption, x => x.key === value.id)
    tabOption.splice(idx, 1)

    this.setState({
      workForceList: tabCopy,
      workForceOption: tabOption
    })
  }
  handleSaveMaterial(value) {
    var tabCopy = this.state.materialList
    tabCopy.push({
      ...value,
      quantity: 0
    })

    var tabOption = this.state.materialsOptions

    var idx = _.findIndex(tabOption, x => x.key === value.id)
    tabOption.splice(idx, 1)

    this.setState({
      materialList: tabCopy,
      materialsOptions: tabOption
    })
  }

  handleDeleteMaterial(row, index) {
    var tabOption = this.state.materialsOptions
    var tabCopy = this.state.materialList

    tabCopy.splice(index, 1)
    tabOption.push({
      text: row.name,
      key: row.id,
      value: {
        ...row,
        quantity: 0
      }
    })
    this.setState({
      materialList: tabCopy,
      materialsOptions: tabOption
    })
  }

  handleDeleteWork(row, index) {
    var tabOption = this.state.workForceOption
    var tabCopy = this.state.workForceList
    tabCopy.splice(index, 1)
    tabOption.push({
      text: row.name,
      key: row.id,
      value: {
        ...row,
        quantity: 0
      }
    })
    this.setState({
      workForceList: tabCopy,
      workForceOption: tabOption
    })
  }

  handleChangeMaterialQuantity(newQty, idx) {
    var materialsCopy = this.state.materialList

    materialsCopy[idx].quantity = newQty
    this.setState({
      materialList: materialsCopy
    })
  }

  handleChangeWorkForceQuantity(newQty, idx) {
    var workCopy = this.state.workForceList

    workCopy[idx].quantity = newQty
    this.setState({
      workForceList: workCopy
    })
  }

  render() {
    let { t, open, handleClose } = this.props
    var  callback = this.props.onSave || function() {}
    return (
      <Modal
        id="modal"
        size="small"
        open={open}
        onClose={handleClose}
      >
        <Modal.Header id="editouvrage">
          {this.state.type == "materials"
            ? t("editMat_title")
            : this.state.type == "workforce"
              ? t("editworkforce_title")
              : t("editwork_title")}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Form.Field>
                <Label className="labelForm">{t("input_modal_name")} </Label>

                <Input
                  placeholder={t("placeholder_modal_name")}
                  value={this.state.name}
                  onChange={(e, val) => this.setState({ name: val.value })}
                />
              </Form.Field>
              <Form.TextArea
                label={t("input_modal_description")}
                placeholder={t("placeholder_modal_description")}
                value={this.state.description}
                onChange={(e, val) => this.setState({ description: val.value })}
              />
              {this.state.type == "materials" ? (
                <Form.Field>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={5}>
                        <Form.Field>
                          <Label className="labelForm">
                            {t("input_modal_unity")}
                          </Label>
                          <Dropdown
                            selection
                            wrapSelection={false}
                            options={this.state.options || []}
                            placeholder="U"
                            value={this.state.unity}
                            onChange={(e, val) =>
                              this.setState({ unity: val.value })
                            }
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column width={6} id="priceColumn">
                        <Form.Field>
                          <Label className="labelForm">
                            {t("input_modal_price_ht")}
                          </Label>
                          <Input
                            labelPosition="right"
                            type="text"
                            placeholder=""
                          >
                            <Input
                              value={this.state.price}
                              onChange={(e, val) =>
                                this.setState({ price: val.value })
                              }
                            />
                            <Label>{t("label_modal_€")}</Label>
                          </Input>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <Button className="modalButtonAction" color="blue">
                          <Icon name="calculator" id="calculatorIcon" />{" "}
                          {t("label_button_modal_calculated")}
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form.Field>
              ) : this.state.type == "work" ? (
                <Form.Field>
                  <Label className="labelForm">
                    {t("category_modal_material")}{" "}
                  </Label>
                  <Segment id="materielsegment">
                    <Grid>
                      {_.map(this.state.materialList, (material, index) => {
                        return (
                          <Grid.Row key={material.id}>
                            <Grid.Column width={4}>
                              <Form.Input
                                id="inputValue"
                                placeholder={material.quantity}
                                value={material.quantity}
                                onChange={(e, val) => {
                                  this.handleChangeMaterialQuantity(
                                    val.value,
                                    index
                                  )
                                }}
                              />
                            </Grid.Column>
                            <Grid.Column width={8}>
                              <Form.Field>
                                <Label className="labelForm">
                                  {" "}
                                  X {material.name + material.reference}
                                </Label>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Form.Field>
                                <Label className="labelForm">
                                  {material.price + t("label_modal_€")}
                                </Label>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={1} id="trashPoubelle">
                              <Icon
                                circular
                                name="trash alternate"
                                className="actionIcon"
                                color="red"
                                onClick={() => {
                                  this.handleDeleteMaterial(material, index)
                                }}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )
                      })}
                      <Grid.Row>
                        <Grid.Column>
                          <Dropdown
                            placeholder={t("input_modal_dropdown_material")}
                            search
                            options={this.state.materialsOptions}
                            selection
                            onChange={(e, val) => {
                              this.handleSaveMaterial(val.value)
                            }}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Segment>

                  <Label className="labelForm">
                    {t("category_modal_worforce")}
                  </Label>
                  <Segment>
                    <Grid>
                      {_.map(this.state.workForceList, (worksforce, index) => {
                        return (
                          <Grid.Row key={worksforce.id}>
                            <Grid.Column width={4}>
                              <Form.Input
                                placeholder={worksforce.quantity}
                                id="inputValue"
                                value={worksforce.quantity}
                                onChange={(e, val) => {
                                  this.handleChangeWorkForceQuantity(
                                    val.value,
                                    index
                                  )
                                }}
                              />
                            </Grid.Column>
                            <Grid.Column width={8}>
                              <Form.Field>
                                <Label className="labelForm">
                                  {" "}
                                  X {worksforce.name}
                                </Label>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={3}>
                              <Form.Field>
                                <Label className="labelForm">
                                  {worksforce.price + t("label_modal_€")}
                                </Label>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={1} id="trashPoubelle">
                              <Icon
                                circular
                                name="trash alternate"
                                className="actionIcon"
                                color="red"
                                onClick={() => {
                                  this.handleDeleteWork(worksforce, index)
                                }}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        )
                      })}
                      <Grid.Row>
                        <Grid.Column>
                          <Dropdown
                            placeholder={t("input_modal_dropdown_workforce")}
                            search
                            selection
                            options={this.state.workForceOption}
                            onChange={(e, val) => {
                              this.handleSaveWork(val.value)
                            }}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Segment>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={5}>
                        <Form.Field>
                          <Label className="labelForm">
                            {t("input_modal_unity")}
                          </Label>
                          <Dropdown
                            value={this.state.unity}
                            onChange={(e, val) =>
                              this.setState({ unity: val.value })
                            }
                            selection
                            wrapSelection={false}
                            options={this.state.options || []}
                            placeholder="U"
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column width={6} id="priceColumn">
                        <Form.Field>
                          <Label className="labelForm">
                            {t("input_modal_price_ht")}
                          </Label>
                          <Input
                            labelPosition="right"
                            type="text"
                            placeholder=""
                          >
                            <Input
                              value={this.state.price}
                              onChange={(e, val) =>
                                this.setState({ price: val.value })
                              }
                            />
                            <Label>{t("label_modal_€")}</Label>
                          </Input>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column width={5}>
                        <Button className="modalButtonAction" color="blue">
                          <Icon name="calculator" id="calculatorIcon" />{" "}
                          {t("label_button_modal_calculated")}
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form.Field>
              ) : (
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <Form.Field>
                        <Label className="labelForm">
                          {t("input_modal_unity")}
                        </Label>
                        <Dropdown
                          value={this.state.unity}
                          onChange={(e, val) =>
                            this.setState({ unity: val.value })
                          }
                          selection
                          wrapSelection={false}
                          options={this.state.options || []}
                          placeholder="U"
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={6} id="priceColumn">
                      <Form.Field>
                        <Label className="labelForm">
                          {t("input_modal_price_ht")}
                        </Label>
                        <Input labelPosition="right" type="text" placeholder="">
                          <Input
                            value={this.state.price}
                            onChange={(e, val) =>
                              this.setState({ price: val.value })
                            }
                          />
                          <Label>{t("label_modal_€")}</Label>
                        </Input>
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <Button className="modalButtonAction" color="blue">
                        <Icon name="calculator" id="calculatorIcon" />{" "}
                        {t("label_button_modal_calculated")}
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Button
          className="modalAction"
          color="lightgrey"
          onClick={handleClose}
        >
          <Icon name="remove" id="removeIcon" />
          {t("button_modal_exit")}
        </Button>
        <Button
          className="modalAction"
          color="green"
          onClick={() => {
            callback(this.state)
            handleClose()
          }}
        >
          <Icon name="checkmark" id="checkmarkIcon" /> {t("button_modal_save")}
        </Button>
      </Modal>
    )
  }
}

export default connect(mapStateToProps)(
  translate("ProModalEditMateriau")(ModalEditMateriau)
)



// WEBPACK FOOTER //
// ./src/components/Pro/Materiaux/ModalEditMateriau.jsx